module.exports = __webpack_public_path__ + "img/product.png?c3b9d91f29fd7eb3e39bb138eb7bfff4";